// src/firebase-config.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// 🔑 Your Firebase config (same as customer app)
const firebaseConfig = {
  apiKey: "AIzaSyD4kySF8VlbEpA5CUBZAGbIJsLqIRAfuN0",
  authDomain: "bookyourneed.firebaseapp.com",
  projectId: "bookyourneed",
  storageBucket: "bookyourneed.appspot.com",
  messagingSenderId: "1077539096749",
  appId: "1:1077539096749:web:12e2b9a1e9a04692b13b1f",
};

// ✅ Prevent duplicate initialization
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export default app;
